import { cn } from '~/style';
import { Motion } from './Motion';

export const DividerDashed = ({ className }: { className?: string }) => {
  return (
    <Motion preset="fade-in">
      <div className={cn('divider-dashed', className)} />
    </Motion>
  );
};
